import { render, staticRenderFns } from "./Desentranhamento.vue?vue&type=template&id=0b9c0cd9"
import script from "./Desentranhamento.vue?vue&type=script&lang=js"
export * from "./Desentranhamento.vue?vue&type=script&lang=js"
import style0 from "./Desentranhamento.vue?vue&type=style&index=0&id=0b9c0cd9&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports